<template>
  <div class="modal-frame modal-medium" :class="{active:isOpen}" data-modal="edit-order">
    <div class="modal-frame-content">
      <button @click="$emit('close')" class="btn-close" rel="button_close" type="button" data-modal-close>
        <svg class="svg-cross">
          <use href="/img/sprite.svg#svg-cross"></use>
        </svg>
      </button>
      <div class="modal-frame-header flex-column">
        <div class="h3">Редактировать</div>
        <div class="label">Выбрано: 3 позиции</div>
      </div>
      <div class="modal-frame-body">
        <form class="order-edit-form grid-gap-20">
          <!--ROW-->
          <div class="form-item">
            <label class="form-label">Склад отгрузки</label>
            <div class="dropdown">
              <button class="dropdown__button" type="button" aria-expanded="false">Юго-Восточный</button>
              <div class="dropdown__list">
                <ul>
                  <li class="dropdown__list-item">
                    <label class="radio-label">
                      <input type="radio" name="office1" value="1" checked>
                      <span class="drop-name">Юго-Восточный</span>
                    </label>
                  </li>
                  <li class="dropdown__list-item">
                    <label class="radio-label">
                      <input type="radio" name="office1" value="2">
                      <span class="drop-name">Центральный</span>
                    </label>
                  </li>
                  <li class="dropdown__list-item">
                    <label class="radio-label">
                      <input type="radio" name="office1" value="3">
                      <span class="drop-name">Северный</span>
                    </label>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!--ROW-->
          <div class="form-item">
            <label class="form-label">Склад поставки</label>
            <div class="dropdown">
              <button class="dropdown__button" type="button" aria-expanded="false">Юго-Восточный</button>
              <div class="dropdown__list">
                <ul>
                  <li class="dropdown__list-item">
                    <label class="radio-label">
                      <input type="radio" name="office1" value="1">
                      <span class="drop-name">Юго-Восточный</span>
                    </label>
                  </li>
                  <li class="dropdown__list-item">
                    <label class="radio-label">
                      <input type="radio" name="office1" value="2" checked>
                      <span class="drop-name">Центральный</span>
                    </label>
                  </li>
                  <li class="dropdown__list-item">
                    <label class="radio-label">
                      <input type="radio" name="office1" value="3">
                      <span class="drop-name">Северный</span>
                    </label>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="two-columns calendar-group">
            <div class="form-item form-calendar">
              <label class="calendar-label">Дата отгрузки заказа</label>
              <div class="calendar-field">
                <input class="calendar-input input-slim" type="text" name="calend1" placeholder="Выбрать" readonly>
                <span class="icon-calendar"></span>
              </div>
            </div>
            <div class="form-item form-calendar">
              <label class="calendar-label">Дата размещения заказа поставщиком</label>
              <div class="calendar-field">
                <input class="calendar-input input-slim" type="text" name="calend2" placeholder="Выбрать" readonly>
                <span class="icon-calendar"></span>
              </div>
            </div>
            <div class="form-item form-calendar">
              <label class="calendar-label">Дата готовности товара к отгрузке на складе поставщика</label>
              <div class="calendar-field">
                <input class="calendar-input input-slim" type="text" name="calend3" placeholder="Выбрать" readonly>
                <span class="icon-calendar"></span>
              </div>
            </div>
            <div class="form-item form-calendar">
              <label class="calendar-label">Расчетная дата поступления по договору</label>
              <div class="calendar-field">
                <input class="calendar-input input-slim" type="text" name="calend4" placeholder="Выбрать" readonly>
                <span class="icon-calendar"></span>
              </div>
            </div>
            <div class="form-item form-calendar">
              <label class="calendar-label">Плановая дата поступления на склад поставщика</label>
              <div class="calendar-field">
                <input class="calendar-input input-slim" type="text" name="calend5" placeholder="Выбрать" readonly>
                <span class="icon-calendar"></span>
              </div>
            </div>
            <div class="form-item form-calendar">
              <label class="calendar-label">Расчетная дата поступления по договору</label>
              <div class="calendar-field">
                <input class="calendar-input input-slim" type="text" name="calend6" placeholder="Выбрать" readonly>
                <span class="icon-calendar"></span>
              </div>
            </div>
          </div>
          <div class="form-buttons flex-1">
            <button class="btn" type="button">Применить</button>
            <button @click="$emit('close')" class="btn-outline" type="button">Отмена</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {bool} from "yup";

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    isOpen: {
      type: bool,
      default: () => false,
    },
  },
  data: () => ({

  }),
  created() {

  },
  computed: {

  },
  methods: {

  }
}
</script>
